<template>
  <div>
    <b-modal
      ref="modalInstrumento"
      size="xl"
      scrollable
      title="Instrumento de Protesto"
      id="modal-dialog"
    >
      <pdf :src="pdf" style="width:100%"></pdf>
    </b-modal>

    <b-modal ref="modalErro" title="Atenção">Nenhum registro encontrado</b-modal>

      <!-- {{item != undefined ? item.length : ''}} -->
    <editaleletronico  :itemsp="items" v-if="tabSelecionado == 3 && items.length > 0 "/>

    <div id="consulta-form" class="d-sm-none d-md-block column-nowrap" v-if="!exibir">
        <div id="banner1">
          <div class="row">
            <div class="col-12 offset-xl-1">
              <div id="textoServico">
                <h1 class="textoRealizarServicos ml-4"><b>Aqui você pode realizar os</b></h1>
                <h1 class="textoRealizarServicos ml-4"><b>serviços dos cartórios de </b></h1>
                <h1 class="textoRealizarServicos ml-4"><b>Protesto online, de forma </b></h1>
                <h1 class="textoRealizarServicos ml-4"><b>simples e prática. </b></h1>
                <br>
                <br>
                <h5 class="textoConsulta ml-4"><b>Consultas Gratuitas</b></h5>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="offset-xl-1 col-12">
              <consultaprotesto @alteraTab="alteracaoTab"></consultaprotesto>
            </div>
          </div>

          <div class="row">
            <div class="col-12 offset-xl-1">
               <div class="row">
                  <div class="col-7 col-xl-7  pr-0 pl-0 shadow ml-5">
                    <the-mask id="input_cpf_cnpj" :mask="['#######################']" :placeholder="descricaoInput" v-model="cpf_cnpj" v-if="tabSelecionado == 4"  />
                    <the-mask id="input_cpf_cnpj" :mask="['###.###.###-##', '##.###.###/####-##']" :placeholder="descricaoInput" v-model="cpf_cnpj" v-else />
                  </div>
                  <div class="div_bt_consultar">
                      <button type="button" class="bt-consultar ml-2" @click="consultar()"><font-awesome-icon size="1x" icon="search"/><b class="ml-2">CONSULTAR</b></button>
                  </div>
               </div>
            </div>
          </div>
            <div class="row">
                <div class="col-12 offset-xl-1">
                    <vue-recaptcha
                      ref="invisibleRecaptcha"
                      @verify="onVerify"
                      @expired="onExpired"
                      size="visible"
                      :sitekey="sitekey"
                    ></vue-recaptcha>
                </div>
            </div>
        </div>

        <contato :title="'New Income'"/>
    </div>
  </div>
</template>

<script>
import API from "../../services/api";
import consultaprotesto from "../../components/consulta_protesto_pesquisa";
import editaleletronico from "../../components/edital_eletronico";
import contato from "../../components/contato";

//import BeatLoader from "vue-spinner/src/BeatLoader.vue";
import VueRecaptcha from "vue-recaptcha";
import { TheMask } from "vue-the-mask";
import pdf from "vue-pdf";

export default {
  components: {
    // BeatLoader,
    VueRecaptcha,
    consultaprotesto,
    TheMask,
    pdf,
    editaleletronico,
    contato
  },
  data() {
    return {
      sitekey: process.env.VUE_APP_sitekeyRecaptcha,//InvisivelV2
      cpf_cnpj: "",
      logged: false,
      documento: "",
      items: [],
      tok: "",
      exibir: false,
      tabSelecionado:1,
      pdf:''
    };
  },
  computed: {
    descricaoInput : function(){
       return this.tabSelecionado == 4 ? 'Digite sua chave' : 'Digite o número do seu CPF ou CNPJ'
    }
  },
  created(){
      /*setTimeout(()=>{
        this.cpf_cnpj = this.$route.params.doc
        document.getElementById("cpf_cnpj").focus()
        this.enviarConsultaAnuencia();
      },0)*/
      // let now = new Date().toISOString().slice(0, 16).toString();
      // console.log(now)
  },
  filters: {
    moeda: function (value) {
      var v = value.replace(/\D/g,'')
      v = (v/100).toFixed(2) + ''
      v = v.replace(".", ",")
      v = v.replace(/(\d)(\d{3})(\d{3}),/g, "$1.$2.$3,")
      v = v.replace(/(\d)(\d{3}),/g, "$1.$2,")
      return v
    },
    uppertitulo: function (value){
      if (!value) return ''
      value = value.toString()
      var vall = value.toLowerCase()
      return vall.charAt(0).toUpperCase() + vall.slice(1)
    },
    uppert: function (value){
      if (!value) return ''
      value = value.toString()
      return value.toUpperCase()
    },
    dataBr: function (value) {
      var str = value;
      var strSplit = str.split("-");
      var ano = strSplit[0];
      var mes = strSplit[1];
      var dia = strSplit[2].substring(0,2);
      //console.log(strSplit);
      return dia +"/"+ mes +"/"+ ano ;
    },
    SomadataBr: function (value) {
      var str = value;
      var strSplit = str.split("-");
      var ano = strSplit[0];
      var mes = strSplit[1];
      var dia = strSplit[2].substring(0,2);
      var data  = new Date(ano, mes, dia);
      data.setDate(data.getDate() + 3);
      var diaf=data.getDate();
      var mesf=data.getMonth();
      var anof=data.getFullYear();
      var minhaData = diaf + '/' + mesf + '/' + anof;

      return minhaData;
    },
    fone: function (value){
      if (value != undefined) {
        var d = ''
        if(value.length > 10){
          d = value
          d = d.replace(/\D/g, "")
          d = d.replace(/^(\d\d)(\d)/g, "($1) $2")
          d = d.replace(/(\d{5})(\d)/, "$1-$2")
          return d
        }else{
          d = value
          d = d.replace(/\D/g, "")
          d = d.replace(/^(\d\d)(\d)/g, "($1) $2")
          d = d.replace(/(\d{4})(\d)/, "$1-$2")
          return d
        }
      }
    },
    documento: function (value) {
      if (value == null) {
          return '';
      } else {
          let v = value;
          //Remove tudo o que não é dígito
          v = v.replace(/\D/g, "");
          if (v.length < 14) { //CPF
              v = v.replace(/(\d{3})(\d)/, "$1.$2");
              v = v.replace(/(\d{3})(\d)/, "$1.$2");
              v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
          } else { //CNPJ
              v = v.replace(/^(\d{2})(\d)/, "$1.$2");
              v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
              v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
              v = v.replace(/(\d{4})(\d)/, "$1-$2");
          }
          return v;
      }
    }
  },
  methods: {
    alteracaoTab(numeroTab){
      this.tabSelecionado = numeroTab
    },
    limparInput() {
      document.getElementById('cpf_cnpj').value="";
      document.getElementById("cpf_cnpj").focus()
  },
    hideModal() {
        this.$refs['modalErro'].hide();
      },
      hideModal2() {
        this.$refs['modalInstrumento'].hide();
      },
    //desableRC: function(e) {
    confirmar(){
      document.getElementById("cpf_cnpj").focus()
    },
    onVerify: function(response) {
      this.tok = response
    },
    validarCPF(str) {
        var Soma;
        var Resto;
        Soma = 0;
        if (str == "00000000000") return false;
        for (let i=1; i<=9; i++)
            Soma = Soma + parseInt(str.substring(i-1, i)) * (11 - i);
        Resto = (Soma * 10) % 11;
        if ((Resto == 10) || (Resto == 11))  Resto = 0;
        if (Resto != parseInt(str.substring(9, 10)) ) return false;
        Soma = 0;
        for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(str.substring(i-1, i)) * (12 - i);
        Resto = (Soma * 10) % 11;
        if ((Resto == 10) || (Resto == 11))  Resto = 0;
        if (Resto != parseInt(str.substring(10, 11) ) ) return false;
        return true;
    },
    validarCNPJ(str) {
        str = str.replace('.','');
        str = str.replace('.','');
        str = str.replace('.','');
        str = str.replace('-','');
        str = str.replace('/','');
        let cnpj = str;
        var numeros, digitos, soma, i, resultado, pos, tamanho, digitos_iguais;
        digitos_iguais = 1;
        if (cnpj.length < 14 && cnpj.length < 15)
            return false;
        for (let i = 0; i < cnpj.length - 1; i++)
            if (cnpj.charAt(i) != cnpj.charAt(i + 1))
        {
            digitos_iguais = 0;
            break;
        }
        if (!digitos_iguais)
        {
            tamanho = cnpj.length - 2
            numeros = cnpj.substring(0,tamanho);
            digitos = cnpj.substring(tamanho);
            soma = 0;
            pos = tamanho - 7;
            for (i = tamanho; i >= 1; i--) {
                soma += numeros.charAt(tamanho - i) * pos--;
                if (pos < 2)
                    pos = 9;
            }
            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if(resultado != digitos.charAt(0))
                return false;
            tamanho = tamanho + 1;
            numeros = cnpj.substring(0,tamanho);
            soma = 0;
            pos = tamanho - 7;
            for (i = tamanho; i >= 1; i--) {
                soma += numeros.charAt(tamanho - i) * pos--;
                if (pos < 2)
                    pos = 9;
            }
            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if(resultado != digitos.charAt(1))
                return false;
            return true;
        }
        else
            return false;
    },
    onExpired: function() {
      this.$refs.invisibleRecaptcha.reset();
    },
    resetRecaptcha() {
      this.$refs.invisibleRecaptcha.reset(); // Direct call reset method
    },
    solicitar(nm_chave, cpfCnpj) {
      if(nm_chave) {
        if(this.validar()){
          //  iniciando solicitação -> login / cadastro
          //  armazena a chave
          localStorage.setItem("nm_chave", nm_chave)
          localStorage.setItem("cpfCnpj", cpfCnpj)
          //  redireciona para login
          this.$router.push({ name: 'login', params: { tipo_login: 'solicitarCancelamentoAnuencia' } })
        } else {
          alert('informe o cpf')
        }
      }
    },
    enviarConsultaAnuencia() {
      this.$refs.invisibleRecaptcha.execute();
    },
    validar() {
      let len = this.cpf_cnpj.length;
      //let doc = this.cpf_cnpj
      return len == 11 || len == 14 ? true : false;
      //return len == 11 ? Serv.validarCPF(doc) : len == 14 ? Serv.validarCNPJ(doc) : false
    },
    placeholderInputConsulta(show) {
      let placeholder = document.getElementById("cpf_ou_cnpj");
      if (show) placeholder.classList.remove("hide");
      else placeholder.classList.add("hide");
    },
    verificaInputConsulta() {
      if (!this.cpf_cnpj) this.placeholderInputConsulta(true);
    },
    inputConsultaFocus() {
      document.getElementById("cpf_cnpj").focus();
    },
    consultarOld() {
      this.$refs.invisibleRecaptcha.execute();
    },
    consultar() {
      //this.tok = response;
      //this.$refs.invisibleRecaptcha.reset();
        let response = this.tok;
      if(this.tabSelecionado == 1)
      {
        let documento = this.cpf_cnpj
        if(response != ''){
          if(this.validar()) {  
              if(documento.length == 11){
                  if(!this.validarCPF(documento)){
                  this.$refs["modalErro"].show();
                  this.msgValida = 'CPF INVÁLIDO'
                  this.exibir = true
                  
                  return false
                }
              }
              if(documento.length == 14){
                  if(!this.validarCNPJ(documento)){
                  this.$refs["modalErro"].show();
                  this.msgValida = 'CNPJ INVÁLIDO'
                  this.exibir = true
                  
                  return false
                }
              }
            this.$router.push({ name: 'consulta', params: { documento: documento, captcha: this.tok } })
          }else{
              this.$refs["modalErro"].show();
              this.msgValida = 'CPF OU CNPJ INVALIDO!'
              this.exibir = true
              
              return false
          }
        }
      }
      else if(this.tabSelecionado == 2){
        if (this.cpf_cnpj) {
          let self = this;
          API.get(`/pesquisa/tituloanuencia/${this.cpf_cnpj}/${this.tok}`)
            .then(res => {
                  if(res.data.result == 1){
                      self.items = res.data['instrumentoProtesto'];
                      self.items = res.data['instrumentoProtesto'];
                      setTimeout(() => {
                        self.$bvModal.show('modal-anuecia-cancelamento');
                      }, 0);
                      this.exibir = false;
                  }else {
                      this.$refs["modalErro"].show();
                      this.exibir = false;
                  }
            })
            .catch(()=> {
              //console.log(e);
              alert("Não foi possivel completar a solicitação");
              this.exibir = false;
            });
        }
      }
      else if(this.tabSelecionado == 3){
        if (this.cpf_cnpj) 
        {
          let self = this;
          this.exibir = false;
          API.get(`/pesquisa/pesquisaEditalEletronico/${this.cpf_cnpj}/${this.tok}`)
            .then(res => {
                  if(res.data.result == 1){
                      self.items = res.data['editalEletronico'];
                      self.items = res.data['editalEletronico'];
                      setTimeout(() => {
                        self.$bvModal.show('modal-edital-eletronico');
                      }, 0);
                      this.exibir = false;
                  }else {
                      this.$refs["modalErro"].show();
                      this.exibir = false;
                  }
            })
            .catch(()=> {
              //console.log(e);
              alert("Não foi possivel completar a solicitação");
              this.exibir = false;
            });
        }
      }
      else if(this.tabSelecionado == 4){
        if (this.cpf_cnpj) {
                //this.exibir = true;
                API.get(`VerifInstProt/${this.cpf_cnpj}/${this.tok}`)
                  .then(res => {
                        if(res.data.result == 1){
                            this.pdf =
                            "data:application/pdf;base64," + res.data.instrumentoProtesto;
                            this.$refs["modalInstrumento"].show();
                            //this.exibir = false;
                        }else {
                            this.$refs["modalErro"].show();
                            //this.exibir = false;
                        }
                  })
                  .catch(()=> {
                    //console.log(e);
                    alert("Não foi possivel completar a solicitação");
                    this.exibir = false;
                  });
        }
      }
      
      
     
      
      this.resetRecaptcha();
    },

  }
};
</script>

<style scoped>
#banner1 {
    height: 100vh !important;
    background-repeat: round !important;
    margin: 0 !important;
}
.row {
  margin-right: 0 !important;
}
.col-12 {
  flex: auto !important;
}
#consulta-form {
  font-family: 'Kanit', sans-serif !important;
}
 #banner1 {
    /* display: flex; */
    background-repeat: no-repeat;
    background-position: left center;
    /* justify-content: center; */
    /* flex-direction: column; */
    background-image: url("~@/assets/imgs/header-mobile.png");
    height: 600px;
    border-top: 3px solid transparent;
    background-position: center;
    background-size: cover;
    margin-bottom: 45px;
    padding-top: 75px;
 }
 #textoServico{
  margin-top: calc(15%);
}

@media (min-width: 900px) {
  #banner1 {
    background-image: url("~@/assets/imgs/header.png");
    height: 800px;
  }
   #textoServico{
    margin-top: calc(7%);
  }
}
.div_bt_consultar{
  text-align : left;
}

#input_cpf_cnpj { 
  width: 101%;
  border: none;
  font-size: 10px; 
  box-shadow: 0 0 0 0;
  outline: 0;
  padding-left: 60px;
  line-height:40px;
  text-align: left;
  border-bottom-left-radius:6px;
}

@media (min-width: 900px) {
  #input_cpf_cnpj { 
    width: 101%;
    border: none;
    font-size: 23px; 
    box-shadow: 0 0 0 0;
    outline: 0;
    padding-left: 60px;
    line-height: 54px;
    text-align: left;
  }
}
.bt-consultar{
  font-family: 'Kanit', sans-serif;
  font-size:12px;
  width: 27vw;
  height: 42px;
  background-color: rgb(63,201,255);
  color:white;
  border: none;
  /* margin-left:63px; */
  border-top-right-radius:6px;
  border-bottom-right-radius: 6px;
}
@media (min-width: 900px) {
  .bt-consultar{
    font-family: 'Kanit', sans-serif;
    font-size:18px;
    width: 17.4vw;
    height: 56px;
    background-color: rgb(63,201,255);
    color:white;
    border: none;
    /* margin-left:63px; */
    border-top-right-radius:6px;
    border-bottom-right-radius: 6px;
  }
}

  .textoRealizarServicos
  {
    color: #084f84;
    font-size: 29px;
    line-height: 25px;
    /* margin-right: 500px; */
    text-align: left;
  }
@media (min-width: 900px) {
  .textoRealizarServicos
  {
    color: #084f84;
    font-size: 39px;
    padding:2px;
    /* margin-right: 500px; */
    text-align: left;
    line-height: 40px;
  }
}
.textoConsulta{
  color: #084f84;
  font-size: 20;
  padding:4px;
  /* margin-right: 500px; */
  text-align: left;
}
.item {
  /* O flex: 1; é necessário para que cada item se expanda ocupando o tamanho máximo do container. */
  flex: 1;
  text-align: center;
  font-size: 1.5em;
}

@media (min-width: 320px) and (max-width: 765px) {
  .textoServico{
    margin-top: 30px;
  }
  .textoRealizarServicos{
  /* margin-top: 150px; */
  /* margin-left: 60px; */
  font-size: 20px;
  padding:0px;

 }
}





</style>